import { labelZodObject } from "@@/shared/labels/label";
import {
    translatableReqZodUnion,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";
import type { ProductFormFieldId } from "../fields/product-form-field-id";
import {
    productFormFieldIdFactory,
    productFormFieldIdZodSchema,
} from "../fields/product-form-field-id";
import { productFormFieldQuantityZodUnion } from "../fields/product-form-field-quantity";

const textDataZodObject = z.object({
    fieldId: productFormFieldIdZodSchema,
    fieldType: z.literal("TEXT"),
    quantity: productFormFieldQuantityZodUnion,
    title: translatableReqZodUnion,
    description: translatableZodSchema,
    required: z.boolean(),
    defaultValue: z.string(),
    labels: z.array(labelZodObject),
});
type TextData = z.infer<typeof textDataZodObject>;

const _factoryParamsZodObject = textDataZodObject.omit({
    fieldId: true,
    fieldType: true,
});
type FactoryParams = z.infer<typeof _factoryParamsZodObject>;

const textDataFactory = (
    input: FactoryParams & {
        fieldId?: ProductFormFieldId;
    },
): TextData => {
    return {
        ...input,
        fieldId: input.fieldId ?? productFormFieldIdFactory(),
        fieldType: "TEXT",
    };
};

export { textDataFactory, textDataZodObject };
export type { TextData, FactoryParams as TextDataFactoryParams };
